import { render, staticRenderFns } from "./SingleMessage.vue?vue&type=template&id=fb15215e&scoped=true&"
import script from "./SingleMessage.vue?vue&type=script&lang=js&"
export * from "./SingleMessage.vue?vue&type=script&lang=js&"
import style0 from "./SingleMessage.vue?vue&type=style&index=0&id=fb15215e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb15215e",
  null
  
)

export default component.exports